var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeObservable, observable } from 'mobx';
import { getSplittestingExperiments } from './api';
import { emitter } from '@lib/react-ab-test';
export class SplittestingStore {
    constructor(defaultVariants) {
        this.isLoading = false;
        this.error = undefined;
        this.data = undefined;
        this.defaultVariants = defaultVariants;
        makeObservable(this, {
            isLoading: observable,
            error: observable,
            load: action
        });
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.error = undefined;
            try {
                this.data = yield getSplittestingExperiments();
            }
            catch (e) {
                this.error = e;
            }
            this.initializeEmitter();
            this.isLoading = false;
        });
    }
    initializeEmitter() {
        var _a, _b;
        for (const experiment in this.defaultVariants) {
            const override = (_a = this.data) === null || _a === void 0 ? void 0 : _a.find(e => e.experiment === experiment);
            const variants = (_b = override === null || override === void 0 ? void 0 : override.variants) !== null && _b !== void 0 ? _b : this.defaultVariants[experiment];
            emitter.defineVariants(experiment, Object.keys(variants), Object.values(variants));
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3BsaXR0ZXN0aW5nL3N0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQUUsY0FBYyxFQUFFLFVBQVUsRUFBRSxNQUFNLE1BQU0sQ0FBQTtBQUN6RCxPQUFPLEVBQXlDLDBCQUEwQixFQUFFLE1BQU0sT0FBTyxDQUFBO0FBQ3pGLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQTtBQUU1QyxNQUFNLE9BQU8saUJBQWlCO0lBUTVCLFlBQWEsZUFBZ0M7UUFQdEMsY0FBUyxHQUFZLEtBQUssQ0FBQTtRQUMxQixVQUFLLEdBQVMsU0FBUyxDQUFBO1FBRXRCLFNBQUksR0FBa0IsU0FBUyxDQUFBO1FBS3JDLElBQUksQ0FBQyxlQUFlLEdBQUcsZUFBZSxDQUFBO1FBQ3RDLGNBQWMsQ0FBQyxJQUFJLEVBQUU7WUFDbkIsU0FBUyxFQUFFLFVBQVU7WUFDckIsS0FBSyxFQUFFLFVBQVU7WUFDakIsSUFBSSxFQUFFLE1BQU07U0FDYixDQUFDLENBQUE7SUFDSixDQUFDO0lBRVksSUFBSTs7WUFDZixJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQTtZQUNyQixJQUFJLENBQUMsS0FBSyxHQUFHLFNBQVMsQ0FBQTtZQUN0QixJQUFJO2dCQUNGLElBQUksQ0FBQyxJQUFJLEdBQUcsTUFBTSwwQkFBMEIsRUFBRSxDQUFBO2FBQy9DO1lBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ1YsSUFBSSxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUE7YUFDZjtZQUdELElBQUksQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1lBQ3hCLElBQUksQ0FBQyxTQUFTLEdBQUcsS0FBSyxDQUFBO1FBQ3hCLENBQUM7S0FBQTtJQUVPLGlCQUFpQjs7UUFDdkIsS0FBSyxNQUFNLFVBQVUsSUFBSSxJQUFJLENBQUMsZUFBZSxFQUFFO1lBQzdDLE1BQU0sUUFBUSxHQUFHLE1BQUEsSUFBSSxDQUFDLElBQUksMENBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLFVBQVUsS0FBSyxVQUFVLENBQUMsQ0FBQTtZQUNsRSxNQUFNLFFBQVEsR0FBRyxNQUFBLFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRSxRQUFRLG1DQUFJLElBQUksQ0FBQyxlQUFlLENBQUMsVUFBVSxDQUFDLENBQUE7WUFDdkUsT0FBTyxDQUFDLGNBQWMsQ0FBQyxVQUFVLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsRUFBRSxNQUFNLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUE7U0FDbkY7SUFDSCxDQUFDO0NBQ0YifQ==